import styled from 'styled-components';

export const Button = styled.button`
  background-color: rgb(46, 95, 148);
  cursor: pointer;
  color: white;

  height: 35px;
  width: 100%;
  margin: 10px 0;
`;
